import styled from 'styled-components';
export var Flex = styled.div.attrs(function (props) {
  return {
    $wrap: props.wrap,
    wrap: undefined,
    $direction: props.direction,
    direction: undefined
  };
}).withConfig({
  displayName: "Flex",
  componentId: "sc-1qqjadj-0"
})(["display:flex;", ";", ";", ";", ";", ";"], function (_ref) {
  var flow = _ref.flow;
  return flow ? "flex-flow: ".concat(flow, ";") : '';
}, function (_ref2) {
  var $direction = _ref2.$direction;
  return $direction ? "flex-direction: ".concat($direction, ";") : '';
}, function (_ref3) {
  var align = _ref3.align;
  return align ? "align-items: ".concat(align, ";") : '';
}, function (_ref4) {
  var justify = _ref4.justify;
  return justify ? "justify-content: ".concat(justify, ";") : '';
}, function (_ref5) {
  var $wrap = _ref5.$wrap;
  return $wrap ? "flex-wrap: ".concat($wrap, ";") : '';
});